export default __webpack_public_path__ + "img/delete-icon.67a7eb6b.svg";